/*
 * בול פרקט - ממשק מחשבון פריסת מסגרות קיר בשופיפיי (שיחה 06)
 * החישוב עצמו ב-bp-frame-engine.js. כאן: קריאת הנתונים מהתבנית, ציור הממשק והוספה לסל.
 * כל הפריטים נכנסים לסל בבקשה אחת (Cart API), ו"פירוט המחשבון" נשמר כמאפיין של השורה.
 * שיחה 15 (16.10): בחיתוך למידה הלקוח מאשר שאין ביטול אחרי תחילת החיתוך (חוק הגנת הצרכן, 14ג(ד)), והאישור נשמר כמאפיין של שורת החיתוך.
 * וגם נגישות: שמות לשדות, הסתרת תיבות הסימון הפנימיות מקורא מסך, וניגודיות בכרטיסי הדגמים.
 */
(function () {
  'use strict';
  var E = window.BPFrameEngine;
  if (!E) { return; }
  var PROP = 'פירוט המחשבון';
  var CUTPROP = 'חיתוך לפי מידה';
  var CUTVAL = 'אושר שאין ביטול אחרי תחילת החיתוך';

  /* ---------- עזרים לקריאת נתונים ---------- */
  function num(s) {
    var m = String(s == null ? '' : s).match(/([0-9]+(?:[.,][0-9]+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }
  /* אורך מוט: אצלנו במטרים (2.4). מספר גדול מ-10 נחשב ס"מ. בלי ערך תקין - 2.4 מטר, כמו באתר הישן */
  function rodCm(raw) {
    var v = num(raw);
    if (v > 0 && v <= 10) { return Math.round(v * 100); }
    if (v > 10 && v <= 600) { return Math.round(v); }
    return 240;
  }
  function cleanName(n) {
    return String(n || '')
      .replace(/\s*(המחיר\s*ל(מוט|יחידה)|מחיר\s*ל(מוט|יחידה)).*/, '')
      .replace(/\s*יחידה\s+באורך.*/, '')
      .trim();
  }
  function modelOf(title) {
    var m = String(title || '').match(/דגם\s*([A-Za-z0-9]+(?:-[A-Za-z0-9]+)?)/);
    return m ? m[1] : '';
  }
  function money(cur, n) {
    return cur + ' ' + (Math.round(n * 100) / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  var esc = E.esc, cm = E.cm;

  function normalize(raw) {
    var C = { cur: raw.cur || '₪', cartAdd: raw.cartAdd, cartUrl: raw.cartUrl, moldings: [], corners: [], kits: [], cut: null };
    (raw.moldings || []).forEach(function (p) {
      if (!p.vid || !(p.price > 0)) { return; }
      C.moldings.push({ id: p.vid, pid: p.pid, wc: p.wc || 0, name: cleanName(p.title), model: modelOf(p.title), group: p.group || '',
        price: Math.round(p.price) / 100, img: p.img || '', url: p.url, stock: p.avail ? 1 : 0,
        rod: rodCm(p.len), h: num(p.height), t: num(p.thick) });
    });
    /* כמו באתר הישן: קודם מה שבמלאי, ואז מהזול ליקר */
    C.moldings.sort(function (a, b) { return a.stock !== b.stock ? b.stock - a.stock : a.price - b.price; });
    (raw.corners || []).forEach(function (p) {
      if (!p.vid || !(p.price > 0)) { return; }
      C.corners.push({ id: p.vid, name: cleanName(p.title), model: modelOf(p.title), group: p.group || '',
        price: Math.round(p.price) / 100, stock: p.avail ? 1 : 0 });
    });
    var basic = [], pro = [];
    (raw.kitItems || []).forEach(function (it) {
      if (!it.vid || !it.avail) { return; }
      var row = { id: it.vid, name: cleanName(it.title), price: Math.round(it.price) / 100, per: +it.per || 0, qty: +it.qty || 0 };
      if (it.kit === 'both') { basic.push(row); }
      pro.push(row);
    });
    if (basic.length) { C.kits.push({ slug: 'basic', label: raw.kitBasicLabel, note: raw.kitBasicNote, items: basic }); }
    if (pro.length) { C.kits.push({ slug: 'pro', label: raw.kitProLabel, note: raw.kitProNote, items: pro }); }
    if (raw.cut && raw.cut.vid) { C.cut = { id: raw.cut.vid, price: Math.round(raw.cut.price) / 100, name: raw.cut.title || 'חיתוך קרניז למידה' }; }
    return C;
  }

  /* ---------- שיחה 15: סגנונות נגישות ותיבת האישור ---------- */
  function addStyle() {
    if (document.getElementById('bpfc-legal-css')) { return; }
    var st = document.createElement('style');
    st.id = 'bpfc-legal-css';
    st.textContent = '.bpfc .bpfc-card .mt,.bpfc .bpfc-card .pr{color:#3d3d3d}' +
      '.bpfc .bpfc-cutok{display:flex;gap:8px;align-items:flex-start;margin:-2px 0 12px;padding:10px 12px;border:1px solid #e0d9c9;border-radius:8px;background:#faf8f3;font-size:14px;line-height:1.5;color:#1f2a24;cursor:pointer}' +
      '.bpfc .bpfc-cutok input{margin-top:3px;width:18px;height:18px;flex:0 0 auto}' +
      '.bpfc .bpfc-cutok a{text-decoration:underline}';
    document.head.appendChild(st);
  }

  /* ---------- המחשבון ---------- */
  function init(root) {
    var dataEl = root.querySelector('script[data-bpfc]');
    if (!dataEl) { return; }
    var C;
    try { C = normalize(JSON.parse(dataEl.textContent)); } catch (e) { return; }
    addStyle();
    var q = function (s) { return root.querySelector(s); };
    if (!C.moldings.length) {
      q('.bpfc-body').innerHTML = '<div class="bpfc-warn">מחשבון פריסת המסגרות אינו זמין כרגע.</div>';
      return;
    }
    var M = function (n) { return money(C.cur, n); };
    var S = { mold: null, walls: [E.newWall()], act: 0, cut: false, cutOk: false, kit: '', corn: false, cornId: 0, search: '' };
    var LAY = E.LAY, LAYMAP = E.LAYMAP, FLD = E.FLD;
    var rodNow = function () { return S.mold ? S.mold.rod : 240; };

    function renderMoldings() {
      var s = (S.search || '').trim().toLowerCase(), out = '';
      var list = C.moldings.filter(function (m) { return !s || (m.name + ' ' + m.model).toLowerCase().indexOf(s) > -1; });
      if (!list.length) { out = '<p style="grid-column:1/-1;opacity:.7">לא נמצא דגם מתאים</p>'; }
      list.forEach(function (m) {
        out += '<button type="button" class="bpfc-card' + (S.mold && S.mold.id === m.id ? ' on' : '') + '" data-id="' + m.id + '" aria-pressed="' + (S.mold && S.mold.id === m.id) + '">' +
          (m.stock ? '' : '<span class="oos">אזל</span>') +
          (m.img ? '<img loading="lazy" src="' + esc(m.img) + '" alt="' + esc(m.name) + '">' : '<div style="height:82px"></div>') +
          '<div class="nm">' + esc(m.name) + '</div>' +
          '<div class="pr">' + M(m.price) + '</div>' +
          '<div class="mt">מוט ' + (m.rod / 100) + ' מ\'' + (m.h ? ' | גובה ' + m.h + ' ס"מ' : '') + '</div></button>';
      });
      q('.bpfc-mold').innerHTML = out;
    }
    function renderTabs() {
      var out = '', i;
      for (i = 0; i < S.walls.length; i++) {
        out += '<div class="bpfc-tab' + (i === S.act ? ' on' : '') + '" data-w="' + i + '" role="button" tabindex="0">קיר ' + (i + 1) +
          (S.walls.length > 1 ? ' <span class="x" data-del="' + i + '" role="button" aria-label="מחיקת קיר ' + (i + 1) + '">&times;</span>' : '') + '</div>';
      }
      out += '<div class="bpfc-tab add" data-add="1" role="button" tabindex="0">+ הוספת קיר</div>';
      q('.bpfc-tabs').innerHTML = out;
    }
    function profile() { return S.mold && S.mold.h ? Math.max(2.5, S.mold.h) : 4; }
    function renderWall() {
      var w = S.walls[S.act], def = LAYMAP[w.lay] || LAY[0], c = E.wallCalc(w, rodNow()), out = '';
      out += '<div class="bpfc-row">' +
        '<div class="bpfc-f"><label>רוחב הקיר (ס"מ)</label><input type="number" inputmode="decimal" min="30" max="2000" step="1" data-dim="W" aria-label="רוחב הקיר בסנטימטרים" value="' + w.W + '"></div>' +
        '<div class="bpfc-f"><label>גובה הקיר (ס"מ)</label><input type="number" inputmode="decimal" min="30" max="600" step="1" data-dim="H" aria-label="גובה הקיר בסנטימטרים" value="' + w.H + '"></div></div>';
      out += '<div style="font-size:14px;font-weight:600;margin:4px 0 8px">בחירת פריסה <span style="font-weight:400;opacity:.65">(' + LAY.length + ' אפשרויות, התצוגה לפי המידות שהזנת)</span></div><div class="bpfc-lay">';
      LAY.forEach(function (l) {
        var g; try { g = l.f(+w.W, +w.H, w.o); } catch (e) { g = { r: [], l: [] }; }
        out += '<div class="l' + (l.id === w.lay ? ' on' : '') + '" data-lay="' + l.id + '" role="button" tabindex="0" aria-pressed="' + (l.id === w.lay) + '">' + E.drawSVG(+w.W, +w.H, g, Math.max(3, (+w.W) / 60), false) + '<span>' + esc(l.n) + '</span></div>';
      });
      out += '</div><details class="bpfc-adv"><summary>כוונון עדין של הפריסה</summary><div class="bpfc-row">';
      def.p.forEach(function (k) {
        var f = FLD[k]; if (!f) { return; }
        out += '<div class="bpfc-f"><label>' + esc(f.l) + '</label><input type="number" inputmode="decimal" min="' + f.min + '" max="' + f.max + '" step="' + (f.st || 1) + '" data-opt="' + k + '" aria-label="' + esc(f.l) + '" value="' + w.o[k] + '"></div>';
      });
      out += '</div></details>';
      out += '<div class="bpfc-prev">' + E.drawSVG(+w.W, +w.H, c.geo, profile(), true) + '</div>';
      if (!c.geo.r.length && !c.geo.l.length) {
        out += '<div class="bpfc-warn">המידות והמרווחים שהזנת לא מאפשרים את הפריסה הזו. נסה להקטין את המרווחים או לבחור פחות מסגרות.</div>';
      }
      var sizes = E.frameSizes(c.geo, ' × ');
      var sz = Object.keys(sizes).map(function (k) { return sizes[k] + ' מסגרות ' + k + ' ס"מ'; }).join(' | ');
      var mm = 0; c.pieces.forEach(function (p) { mm += p.len; });
      out += '<div class="bpfc-wsum">' +
        '<div class="bpfc-kpi"><b>' + c.geo.r.length + '</b><span>מסגרות בקיר</span></div>' +
        '<div class="bpfc-kpi"><b>' + c.pieces.length + '</b><span>חיתוכים</span></div>' +
        '<div class="bpfc-kpi"><b>' + cm(mm / 100) + '</b><span>מטר רץ קרניז</span></div></div>';
      if (sz) { out += '<div style="font-size:13px;opacity:.8;margin-top:9px">מידות המסגרות: ' + esc(sz) + '</div>'; }
      q('.bpfc-wall').innerHTML = out;
    }
    function renderExtras() {
      var t = E.calcAll(S), rods = t.rods, out = '';
      if (C.cut) {
        out += '<div class="bpfc-opt' + (S.cut ? ' on' : '') + '" data-t="cut" role="checkbox" tabindex="0" aria-checked="' + S.cut + '"><input type="checkbox" tabindex="-1" aria-hidden="true" ' + (S.cut ? 'checked' : '') + '>' +
          '<div class="t"><b>שירות חיתוך למידה - הקרניז מגיע חתוך ומוכן</b>' +
          '<small>אנחנו חותכים עבורך את כל ' + t.pieces + ' החיתוכים לפי הרשימה שהמחשבון הפיק, כולל זוויות 45 מעלות בפינות. ' + M(C.cut.price) + ' לכל מוט.</small></div>' +
          '<div class="p">' + M(C.cut.price * rods) + '</div></div>';
        if (S.cut) {
          out += '<label class="bpfc-cutok"><input type="checkbox" data-cutok="1" required aria-required="true"' + (S.cutOk ? ' checked' : '') + '><span>ידוע לי שהקרניז נחתך לפי המידות שהזמנתי, ושאחרי שהחיתוך מתחיל אי אפשר לבטל את העסקה, אלא אם המוצר פגום או לא תואם להזמנה. <a href="/policies/refund-policy" target="_blank">מדיניות הביטול</a></span></label>';
        }
      }
      if (C.kits.length) {
        out += '<div style="font-size:14px;font-weight:600;margin:16px 0 8px" id="bpfc-kit-h">קיט התקנה</div>';
        out += '<div role="radiogroup" aria-labelledby="bpfc-kit-h">';
        out += '<div class="bpfc-opt' + (S.kit === '' ? ' on' : '') + '" data-kit="" role="radio" tabindex="0" aria-checked="' + (S.kit === '') + '"><input type="radio" tabindex="-1" aria-hidden="true" ' + (S.kit === '' ? 'checked' : '') + '>' +
          '<div class="t"><b>בלי קיט</b><small>יש לי כבר את חומרי ההדבקה והכלים</small></div><div class="p">-</div></div>';
        C.kits.forEach(function (k) {
          var sum = 0, ch = '';
          k.items.forEach(function (it) { var qy = E.kitQty(it, rods); sum += qy * it.price; ch += '<span>' + esc(it.name) + ' - ' + qy + ' יח\'</span>'; });
          out += '<div class="bpfc-opt' + (S.kit === k.slug ? ' on' : '') + '" data-kit="' + k.slug + '" role="radio" tabindex="0" aria-checked="' + (S.kit === k.slug) + '"><input type="radio" tabindex="-1" aria-hidden="true" ' + (S.kit === k.slug ? 'checked' : '') + '>' +
            '<div class="t"><b>' + esc(k.label) + '</b><small>' + esc(k.note) + '</small><div class="bpfc-kititems">' + ch + '</div></div>' +
            '<div class="p">' + M(sum) + '</div></div>';
        });
        out += '</div>';
      }
      var cs = E.matchCorners(S, C);
      if (!cs.length) { S.corn = false; S.cornId = 0; }
      if (cs.length && t.frames) {
        if (!S.cornId || !cs.some(function (c) { return c.id === S.cornId; })) { S.cornId = cs[0].id; }
        var cobj = cs.filter(function (c) { return c.id === S.cornId; })[0] || cs[0], cq = t.frames * 4;
        out += '<div style="font-size:14px;font-weight:600;margin:16px 0 8px">פינות דקורטיביות מוכנות לדגם ' + esc(S.mold.model) + ' (רשות)</div>';
        out += '<div class="bpfc-opt' + (S.corn ? ' on' : '') + '" data-t="corn" role="checkbox" tabindex="0" aria-checked="' + S.corn + '"><input type="checkbox" tabindex="-1" aria-hidden="true" ' + (S.corn ? 'checked' : '') + '>' +
          '<div class="t"><b>הוספת פינות מוכנות - 4 לכל מסגרת</b>' +
          '<small>פינה דקורטיבית יצוקה שמחליפה את חיתוך ה-45 בפינה ונותנת גימור עשיר. ' + cq + ' פינות ל-' + t.frames + ' מסגרות.</small></div>' +
          '<div class="p">' + M(cobj.price * cq) + '</div></div>';
        if (S.corn) {
          out += '<div class="bpfc-f" style="margin-top:-4px;margin-bottom:10px"><label for="bpfc-corn-sel">דגם הפינה</label><select id="bpfc-corn-sel" data-corn="1">';
          cs.forEach(function (c) { out += '<option value="' + c.id + '"' + (c.id === S.cornId ? ' selected' : '') + '>' + esc(c.name) + ' - ' + M(c.price) + '</option>'; });
          out += '</select></div>';
        }
      }
      q('.bpfc-extras').innerHTML = out || '<p style="opacity:.7;margin:0">אין תוספות לדגם הזה.</p>';
    }
    function renderSummary() {
      var el = q('.bpfc-sum'), t = E.calcAll(S), out = '';
      if (!S.mold) { el.innerHTML = '<div class="bpfc-warn">בחר קודם דגם קרניז בשלב 1.</div>'; return; }
      if (!t.rods) { el.innerHTML = '<div class="bpfc-warn">אין עדיין פריסה לחישוב. בדוק את המידות והמרווחים.</div>'; return; }
      var tt = E.totals(S, C, t);
      out += '<div class="bpfc-wsum" style="margin-bottom:14px">' +
        '<div class="bpfc-kpi"><b>' + S.walls.length + '</b><span>קירות</span></div>' +
        '<div class="bpfc-kpi"><b>' + t.frames + '</b><span>מסגרות</span></div>' +
        '<div class="bpfc-kpi"><b>' + cm(t.meters) + '</b><span>מטר רץ</span></div>' +
        '<div class="bpfc-kpi"><b>' + t.rods + '</b><span>מוטות ' + (t.rod / 100) + ' מ\'</span></div></div>';
      if (t.walls > 1 && t.solo > t.rods) {
        var sv = t.solo - t.rods;
        out += '<div class="bpfc-share">השאריות מנוצלות בין הקירות: ' + (t.shared === 1 ? 'מוט אחד משמש' : t.shared + ' מוטות משמשים') + ' יותר מקיר אחד, וכך ' + (sv === 1 ? 'נחסך מוט אחד' : 'נחסכים ' + sv + ' מוטות') + ' ביחס לחישוב של כל קיר בנפרד.</div>';
      }
      if (t.splitSaved > 0) {
        out += '<div class="bpfc-share">צלעות ארוכות ממוט אחד חולקו למוטות שלמים ולחלק קצר אחד, שנכנס לשארית של מוט אחר. כך ' + (t.splitSaved === 1 ? 'נחסך מוט אחד' : 'נחסכים ' + t.splitSaved + ' מוטות') + '. החיבורים באמצע הצלע חתוכים ישר, והפינות ב-45 מעלות.</div>';
      }
      out += '<table class="bpfc-tbl"><thead><tr><th>פריט</th><th>כמות</th><th>מחיר</th></tr></thead><tbody>';
      out += '<tr><td>' + esc(S.mold.name) + '</td><td>' + t.rods + ' מוטות</td><td>' + M(tt.mold) + '</td></tr>';
      if (S.cut && C.cut) { out += '<tr><td>' + esc(C.cut.name) + '</td><td>' + t.rods + '</td><td>' + M(tt.cut) + '</td></tr>'; }
      var k = S.kit ? E.kitBySlug(C, S.kit) : null;
      if (k) { k.items.forEach(function (it) { var qy = E.kitQty(it, t.rods); out += '<tr><td>' + esc(it.name) + '</td><td>' + qy + '</td><td>' + M(qy * it.price) + '</td></tr>'; }); }
      if (S.corn && tt.corn) {
        var co = E.matchCorners(S, C).filter(function (c) { return c.id === S.cornId; })[0];
        out += '<tr><td>' + esc(co.name) + '</td><td>' + (t.frames * 4) + '</td><td>' + M(tt.corn) + '</td></tr>';
      }
      out += '</tbody></table>';
      out += '<details class="bpfc-adv"><summary>רשימת החיתוכים המלאה וחלוקה למוטות</summary><div class="bpfc-cuts" style="margin-top:10px">';
      E.cutSheet(S, t.split).forEach(function (c) { out += '<span class="bpfc-chip">' + c.n + ' x ' + cm(c.len) + ' ס"מ (' + c.ang + ')</span>'; });
      out += '<table class="bpfc-tbl" style="margin-top:10px"><thead><tr><th>מוט</th><th>חיתוכים (ס"מ)</th><th>שארית</th></tr></thead><tbody>';
      t.bins.forEach(function (b, i) { out += '<tr><td>' + (i + 1) + '</td><td>' + E.binTxt(b, t.walls > 1) + '</td><td>' + cm(Math.max(0, b.rem)) + '</td></tr>'; });
      out += '</tbody></table></div></details>';
      out += '<div class="bpfc-tot"><span>סה"כ להזמנה</span><b>' + M(tt.total) + '</b></div>';
      if (!S.mold.stock) { out += '<div class="bpfc-warn">הדגם שנבחר מסומן כאזל מהמלאי. אפשר להוסיף לסל ולבדוק זמינות מולנו, או לבחור דגם אחר.</div>'; }
      out += '<button type="button" class="bpfc-btn" data-act="add">הוספה לסל</button>';
      out += '<button type="button" class="bpfc-btn sec" data-act="print">הדפסת רשימת החיתוכים</button>';
      out += '<div class="bpfc-msg" role="status" aria-live="polite"></div>';
      el.innerHTML = out;
    }
    function render() { renderMoldings(); renderTabs(); renderWall(); renderExtras(); renderSummary(); }

    /* ---------- אירועים ---------- */
    q('.bpfc-q').addEventListener('input', function (e) { S.search = e.target.value; renderMoldings(); });
    function onActivate(e) {
      var el;
      if (e.target.closest('.bpfc-cutok')) { return; }
      el = e.target.closest('.bpfc-card');
      if (el && el.dataset.id) {
        var id = +el.dataset.id;
        S.mold = C.moldings.filter(function (m) { return m.id === id; })[0] || null;
        S.corn = false; S.cornId = 0; render(); return;
      }
      el = e.target.closest('[data-del]');
      if (el) { e.stopPropagation(); S.walls.splice(+el.dataset.del, 1); if (S.act >= S.walls.length) { S.act = S.walls.length - 1; } render(); return; }
      el = e.target.closest('[data-add]');
      if (el) { if (S.walls.length >= 12) { return; } var cp = S.walls[S.act]; S.walls.push({ W: cp.W, H: cp.H, lay: cp.lay, o: JSON.parse(JSON.stringify(cp.o)) }); S.act = S.walls.length - 1; render(); return; }
      el = e.target.closest('[data-w]');
      if (el) { S.act = +el.dataset.w; render(); return; }
      el = e.target.closest('[data-lay]');
      if (el) { S.walls[S.act].lay = el.dataset.lay; renderWall(); renderExtras(); renderSummary(); return; }
      el = e.target.closest('[data-t="cut"]');
      if (el) { S.cut = !S.cut; if (!S.cut) { S.cutOk = false; } renderExtras(); renderSummary(); return; }
      el = e.target.closest('[data-t="corn"]');
      if (el) { S.corn = !S.corn; renderExtras(); renderSummary(); return; }
      el = e.target.closest('[data-kit]');
      if (el) { S.kit = el.dataset.kit; renderExtras(); renderSummary(); return; }
      el = e.target.closest('[data-act]');
      if (el && el.dataset.act === 'add') { addToCart(); return; }
      if (el && el.dataset.act === 'print') { doPrint(); }
    }
    root.addEventListener('click', onActivate);
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[role="button"],[role="radio"],[role="checkbox"]')) { e.preventDefault(); onActivate(e); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.dataset && e.target.dataset.corn) { S.cornId = +e.target.value; renderExtras(); renderSummary(); }
      if (e.target.dataset && e.target.dataset.cutok) { S.cutOk = !!e.target.checked; }
    });
    root.addEventListener('input', function (e) {
      var t = e.target, w = S.walls[S.act], v;
      if (t.dataset && t.dataset.dim) {
        v = parseFloat(t.value); if (!isFinite(v) || v <= 0) { return; }
        w[t.dataset.dim] = Math.min(t.dataset.dim === 'W' ? 2000 : 600, Math.max(30, v));
        refreshPreview(); return;
      }
      if (t.dataset && t.dataset.opt) {
        var k = t.dataset.opt, f = FLD[k]; v = parseFloat(t.value);
        if (!isFinite(v)) { return; }
        w.o[k] = Math.min(f.max, Math.max(f.min, v));
        refreshPreview();
      }
    });
    var rt = null;
    function refreshPreview() {
      var w = S.walls[S.act], c = E.wallCalc(w, rodNow()), pv = q('.bpfc-prev');
      if (pv) { pv.innerHTML = E.drawSVG(+w.W, +w.H, c.geo, profile(), true); }
      clearTimeout(rt);
      rt = setTimeout(function () {
        var a = document.activeElement, k = a && a.dataset ? (a.dataset.opt || a.dataset.dim) : null, ss = a ? a.selectionStart : null;
        renderWall(); renderExtras(); renderSummary();
        if (k) {
          var n2 = q('[data-opt="' + k + '"]') || q('[data-dim="' + k + '"]');
          if (n2) { var dt = q('.bpfc-adv'); if (dt && n2.closest('.bpfc-adv')) { dt.open = true; } n2.focus(); try { n2.setSelectionRange(ss, ss); } catch (err) {} }
        }
      }, 450);
    }

    function doPrint() {
      var t = E.calcAll(S), w2 = window.open('', '_blank');
      if (!w2) { return; }
      var d2 = w2.document;
      d2.title = 'רשימת חיתוך - בול פרקט';
      d2.documentElement.setAttribute('dir', 'rtl');
      var st = d2.createElement('style');
      st.textContent = 'body{font-family:Arial;padding:24px;direction:rtl}h1{font-size:20px}pre{white-space:pre-wrap;font-family:Arial;font-size:14px;line-height:1.8}';
      d2.head.appendChild(st);
      var h1 = d2.createElement('h1'); h1.textContent = 'רשימת חיתוך - מחשבון מסגרות קיר, בול פרקט';
      var pre = d2.createElement('pre'); pre.textContent = E.cutNote(S, t);
      d2.body.appendChild(h1); d2.body.appendChild(pre);
      setTimeout(function () { w2.print(); }, 500);
    }

    function addToCart() {
      var t = E.calcAll(S), list = E.buildItems(S, C, t), btn = q('[data-act="add"]'), msg = q('.bpfc-msg');
      if (!list.length) { return; }
      /* שיחה 15: חיתוך למידה נכנס לסל רק אחרי אישור שאין ביטול אחרי תחילת החיתוך */
      if (S.cut && C.cut && !S.cutOk) {
        msg.className = 'bpfc-msg err';
        msg.textContent = 'בחרת שירות חיתוך למידה. כדי להמשיך יש לסמן בשלב 3 שידוע לך שאחרי תחילת החיתוך אי אפשר לבטל.';
        var ck = q('[data-cutok]');
        if (ck) { ck.scrollIntoView({ block: 'center', behavior: 'smooth' }); ck.focus(); }
        return;
      }
      var items = list.map(function (it) {
        var row = { id: it.id, quantity: Math.min(500, it.qty) };
        if (it.note) { row.properties = {}; row.properties[PROP] = it.note.slice(0, 4000); }
        if (S.cut && C.cut && it.id === C.cut.id) { row.properties = row.properties || {}; row.properties[CUTPROP] = CUTVAL; }
        return row;
      });
      btn.disabled = true; btn.textContent = 'מוסיף לסל...';
      fetch(C.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false; btn.textContent = 'הוספה לסל';
          if (res.ok) {
            var n = (res.j.items || []).length;
            msg.className = 'bpfc-msg ok';
            msg.innerHTML = 'נוספו ' + n + ' פריטים לסל. <a href="' + C.cartUrl + '" style="font-weight:700;text-decoration:underline">מעבר לסל</a>';
            document.dispatchEvent(new CustomEvent('bp:frame-calc:added', { detail: { items: items } }));
            setTimeout(function () { window.location.href = C.cartUrl; }, 1200);
          } else {
            msg.className = 'bpfc-msg err';
            msg.textContent = (res.j && (res.j.description || res.j.message)) || 'משהו השתבש. אפשר לרענן ולנסות שוב.';
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'הוספה לסל';
          msg.className = 'bpfc-msg err'; msg.textContent = 'שגיאת תקשורת. אפשר לרענן ולנסות שוב.';
        });
    }

    /* ---------- אתחול: ?bpm= מקבל מזהה מוצר בשופיפיי או מזהה ווקומרס ישן ---------- */
    var pre = 0;
    try { pre = parseInt(new URLSearchParams(window.location.search).get('bpm'), 10) || 0; } catch (e) {}
    if (pre) { S.mold = C.moldings.filter(function (m) { return m.pid === pre || m.wc === pre || m.id === pre; })[0] || null; }
    if (!S.mold) { S.mold = C.moldings.filter(function (m) { return m.stock; })[0] || C.moldings[0]; }
    render();
    if (pre) { setTimeout(function () { var s2 = q('.bpfc-s2'); if (s2) { s2.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }, 350); }
  }

  function boot() { document.querySelectorAll('.bpfc[data-bpfc-root]').forEach(function (el) { if (!el.__bpfc) { el.__bpfc = 1; init(el); } }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
